import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useState } from 'react';

/** A prompt in full, scrollable and copyable — ADMIN-25, shared by ADMIN-26. */
export function PromptBlock({
  text,
  label = 'System prompt',
}: {
  text: string;
  label?: string;
}) {
  const [copied, setCopied] = useState(false);

  return (
    <Stack spacing={1}>
      <Stack direction="row" sx={{ justifyContent: 'flex-end' }}>
        <Button
          size="small"
          variant="outlined"
          onClick={() => {
            void navigator.clipboard.writeText(text).then(() => {
              setCopied(true);
            });
          }}
        >
          {copied ? 'Copied' : 'Copy'}
        </Button>
      </Stack>
      <Typography
        component="pre"
        variant="body2"
        aria-label={label}
        sx={{
          m: 0,
          p: 1,
          fontFamily: 'monospace',
          whiteSpace: 'pre-wrap',
          overflow: 'auto',
          maxHeight: '60vh',
          bgcolor: 'action.hover',
        }}
      >
        {text}
      </Typography>
    </Stack>
  );
}
